import { useState } from 'react';
import { Line } from '../types';

interface LineManagerProps {
  lines: Line[];
  onLinesUpdate: (lines: Line[] | ((prevLines: Line[]) => Line[])) => void;
  selectedHeaderToOrg?: string;
}

export const useLineManager = ({ lines, onLinesUpdate, selectedHeaderToOrg }: LineManagerProps) => {
  const [newRowIds, setNewRowIds] = useState<Set<string>>(new Set());



  const updateLine = (lineId: string, field: string, value: string) => {
    const fieldMap: Record<string, keyof Line> = {
      'Validated Serial Number': 'validatedSerialNumber',
      'Validated Asset Number': 'validatedAssetNumber',
      'To Subinventory': 'toSubinventory',
      'To Locator': 'toLocator',
      'Validated Serial Item': 'validatedSerialItem',
      'Repair Eligibility': 'repairEligibility',
      'Tracking Number': 'trackingNumber',
      'pallet': 'pallet',
      'subinventory': 'subinventory',
      'cage': 'cage',
      'tote': 'tote',
      'status': 'status'
    };

    // Use functional update to get the most current lines
    onLinesUpdate((currentLines: Line[]) => {
      const updatedLines = currentLines.map((line: Line) => {
        if (line.id === lineId) {
          const updatedLine = { ...line, [fieldMap[field]]: value };
          return updatedLine;
        }
        return line;
      });
      
      return updatedLines;
    });
  };

  const cancelChanges = () => {
    // Remove new rows and revert to original state
    onLinesUpdate([]);
    setNewRowIds(new Set());
  };

  const clearNewRowIds = () => {
    setNewRowIds(new Set());
  };

  return {
    updateLine,
    cancelChanges,
    clearNewRowIds,
    newRowIds
  };
};